module.exports = __webpack_public_path__ + "assets/icon-conductor-rope5.b61b026c.svg";